import { PlaceSelectProp } from "@/Atoms/Select/PlaceSelect";
import { components, OptionProps } from "react-select";
import { LocationIcon } from "@/Atoms/Select/Select";
import testId from "@/utils/testId";
import styles from './PlaceOption.module.scss';

export default (props: OptionProps & {
  data: PlaceSelectProp,
}) => {
  const {data, innerRef, innerProps} = props

  if (data.__isNew__) {
    return (
      <components.Option {...props}>
        Nieuwe plaats toevoegen: <strong>{data.label}</strong>
      </components.Option>
    );
  }

  return <div ref={innerRef} {...innerProps} className={styles.option}  {...testId('select-option')}>
    <div className={styles.icon}>
      <LocationIcon type={data.type} />
    </div>
    <div className={styles.wrapper}>
      <div className={styles.title}>{data.label}</div>
      <div className={styles.sub}>{data.description}</div>
    </div>
  </div>
}